// --------------- LIBRARIES ---------------
import { put, call, takeEvery, all } from 'redux-saga/effects'

// --------------- ASSETS ---------------
import { GetUsers, GetUser, UpdateUser, DeleteUser } from '../Types'
import { getUsers, getUser, updateUser, deleteUser } from '../actions'
import Api from '../../services/Api'

const getUsersSaga = function* getUsersSaga({ params }) {
  try {
    const response = yield call(Api.getUsers, params)
    // if (response?.status == '1') {
    yield put(getUsers.Success(response))
    // } else yield put(getUserProfile.Failed(response))
  } catch (error) {
    yield put(getUsers.Failed(error))
  }
}

const getUserSaga = function* getUserSaga({ params }) {
  try {
    const response = yield call(Api.getUser, params)
    yield put(getUser.Success(response))
  } catch (error) {
    yield put(getUser.Failed(error))
  }
}
function* userSaga() {
  const updateUserSaga = function* updateUserSaga({ params }) {
    try {
      const { id, body } = params
      const response = yield call(Api.updateUser, id, body)
      yield put(updateUser.Success(response))
    } catch (error) {
      yield put(updateUser.Failed(error))
    }
  }

  const deleteUserSaga = function* deleteUserSaga({ params }) {
    try {
      const response = yield call(Api.deleteUser, params)
      yield put(deleteUser.Success(response))
    } catch (error) {
      yield put(deleteUser.Failed(error))
    }
  }

  yield all([
    takeEvery(GetUsers.REQUEST, getUsersSaga),
    takeEvery(GetUser.REQUEST, getUserSaga),
    takeEvery(UpdateUser.REQUEST, updateUserSaga),
    takeEvery(DeleteUser.REQUEST, deleteUserSaga),
  ])
}

export default userSaga
